/* ThermoCore theme: product form, gallery, recommendations */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    format = format || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }


  /* Cart: add, change quantity, slide-out drawer. Falls back to the /cart page if anything fails. */
  var Cart = (function () {
    var config = window.themeCart || { type: 'page', root: '/', cartUrl: '/cart' };
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || config.root || '/';
    var lastFocus = null;

    function drawer() { return document.querySelector('[data-cart-drawer]'); }
    function useDrawer() { return config.type === 'drawer' && !!drawer(); }

    function request(path, body) {
      if (useDrawer()) {
        body.sections = 'cart-drawer';
        body.sections_url = window.location.pathname;
      }
      return fetch(root + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok || json.status) throw new Error(json.description || json.message || 'Something went wrong. Please try again.');
          return json;
        });
      });
    }

    function setCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = !count;
      });
      document.querySelectorAll('[data-cart-open]').forEach(function (el) {
        el.setAttribute('aria-label', 'Cart, ' + count + ' items');
      });
    }

    function renderDrawer(sections) {
      var el = drawer();
      if (!el || !sections || !sections['cart-drawer']) return false;
      var tmp = document.createElement('div');
      tmp.innerHTML = sections['cart-drawer'];
      var fresh = tmp.querySelector('[data-cart-drawer]');
      if (!fresh) return false;
      el.innerHTML = fresh.innerHTML;
      el.dataset.count = fresh.dataset.count;
      setCount(Number(fresh.dataset.count));
      return true;
    }

    function open() {
      var el = drawer();
      if (!el) { window.location.href = config.cartUrl; return; }
      lastFocus = document.activeElement;
      el.hidden = false;
      document.documentElement.classList.add('cart-open');
      requestAnimationFrame(function () { el.classList.add('is-open'); });
      var panel = el.querySelector('.cart-drawer__panel');
      if (panel) panel.focus();
    }

    function close() {
      var el = drawer();
      if (!el || el.hidden) return;
      el.classList.remove('is-open');
      document.documentElement.classList.remove('cart-open');
      setTimeout(function () { el.hidden = true; }, 250);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function add(id, quantity) {
      return request('cart/add.js', { items: [{ id: id, quantity: quantity || 1 }] }).then(function (json) {
        if (useDrawer() && renderDrawer(json.sections)) {
          open();
        } else {
          window.location.href = config.cartUrl;
        }
      });
    }

    function change(line, quantity) {
      var el = drawer();
      if (el) el.classList.add('is-busy');
      return request('cart/change.js', { line: line, quantity: quantity })
        .then(function (json) {
          if (!renderDrawer(json.sections)) setCount(json.item_count);
        })
        .catch(function (err) {
          var errEl = el && el.querySelector('[data-cart-error]');
          if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
        })
        .then(function () { if (el) el.classList.remove('is-busy'); });
    }

    document.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-cart-open]');
      if (openBtn && useDrawer()) { event.preventDefault(); open(); return; }
      if (event.target.closest('[data-cart-close]')) { event.preventDefault(); close(); return; }
      var qtyBtn = event.target.closest('[data-qty-change]');
      if (qtyBtn) {
        event.preventDefault();
        change(Number(qtyBtn.dataset.line), Math.max(0, Number(qtyBtn.dataset.qtyChange)));
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    return { add: add, change: change, open: open, close: close };
  })();

  function initProduct(section) {
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var groups = section.querySelectorAll('.variant-picker__group');
    var idInput = section.querySelector('[data-variant-id]');
    var qtyInput = section.querySelector('[data-quantity]');
    var addButton = section.querySelector('[data-add-button]');
    var addLabel = section.querySelector('[data-add-label]');
    var priceEl = section.querySelector('[data-product-price]');
    var packInputs = section.querySelectorAll('[data-pack-qty]');
    var errorEl = section.querySelector('[data-form-error]');
    var form = section.querySelector('[data-product-form]');

    function currentVariant() {
      if (!groups.length) return data.variants[0];
      var selected = [];
      groups.forEach(function (group) {
        var checked = group.querySelector('input:checked');
        selected[Number(group.dataset.optionIndex)] = checked ? checked.value : null;
      });
      return data.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function markAvailability() {
      // Grey out values that have no available variant given the other selections.
      groups.forEach(function (group) {
        var idx = Number(group.dataset.optionIndex);
        var others = [];
        groups.forEach(function (g) {
          var c = g.querySelector('input:checked');
          others[Number(g.dataset.optionIndex)] = c ? c.value : null;
        });
        group.querySelectorAll('input').forEach(function (input) {
          var trial = others.slice();
          trial[idx] = input.value;
          var match = data.variants.find(function (v) {
            return v.options.every(function (opt, i) { return opt === trial[i]; });
          });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function update() {
      var variant = currentVariant();
      groups.forEach(function (group) {
        var checked = group.querySelector('input:checked');
        var label = group.querySelector('[data-selected-label]');
        if (checked && label) label.textContent = checked.dataset.display || checked.value;
      });
      markAvailability();
      if (!variant) {
        addButton.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (priceEl) {
        var html = '<span class="price__current">' + formatMoney(variant.price, data.money_format) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s class="price__compare">' + formatMoney(variant.compare_at_price, data.money_format) + '</s>';
        }
        priceEl.innerHTML = '<span class="price__wrap">' + html + '</span>';
      }
      section.querySelectorAll('[data-pack-price]').forEach(function (el) {
        el.textContent = formatMoney(variant.price * Number(el.dataset.packPrice), data.money_format);
      });
      if (variant.media_id) showMedia(variant.media_id);
      if (section.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function showMedia(mediaId) {
      var slide = section.querySelector('[data-media-id="' + mediaId + '"]');
      var track = section.querySelector('[data-gallery-track]');
      if (slide && track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      section.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.thumb === String(mediaId));
      });
    }

    groups.forEach(function (group) {
      group.addEventListener('change', update);
    });
    packInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (qtyInput) qtyInput.value = input.value;
      });
    });
    section.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(thumb.dataset.thumb); });
    });
    var sizeLink = section.querySelector('[data-open-size-chart]');
    if (sizeLink) {
      sizeLink.addEventListener('click', function () {
        var target = section.querySelector(sizeLink.getAttribute('href'));
        if (target) target.open = true;
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        if (!window.fetch) return;
        event.preventDefault();
        if (errorEl) errorEl.hidden = true;
        addButton.disabled = true;
        addButton.setAttribute('aria-busy', 'true');
        Cart.add(Number(idInput.value), Number(qtyInput ? qtyInput.value : 1))
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          })
          .then(function () {
            addButton.removeAttribute('aria-busy');
            var v = currentVariant();
            addButton.disabled = !(v && v.available);
          });
      });
    }

    groups.forEach(function (group) {
      var checked = group.querySelector('input:checked');
      var label = group.querySelector('[data-selected-label]');
      if (checked && label) label.textContent = checked.dataset.display || checked.value;
    });
    markAvailability();
  }

  function initGallery(gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    if (!track || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var id = entry.target.dataset.mediaId;
          gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
            t.classList.toggle('is-active', t.dataset.thumb === id);
          });
        }
      });
    }, { root: track, threshold: 0.6 });
    track.querySelectorAll('[data-media-id]').forEach(function (slide) { observer.observe(slide); });
  }

  function initRecommendations(el) {
    var url = el.dataset.url;
    if (!url || el.children.length) return;
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var inner = html.querySelector('[data-recommendations]');
        if (inner && inner.innerHTML.trim().length) el.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
